import { HttpApiService } from "@/shared/services/httpApi.service";
import type { StepUpState } from "@/shared/types/user.entity";

interface SetSecurityPinBody {
  pin: string;
  current_password: string;
}

interface RemoveSecurityPinBody {
  current_password: string;
}

/**
 * The caller's own security PIN (coloca-nest `POST /auth/security-pin[/remove]`). Both need the account
 * password and answer the new step-up state, which the auth slice merges into the user.
 */
export const SecurityPinService = {
  set: async (body: SetSecurityPinBody): Promise<StepUpState> => {
    const response = await HttpApiService.post<StepUpState, SetSecurityPinBody>("/auth/security-pin", body);
    return response.data;
  },

  remove: async (body: RemoveSecurityPinBody): Promise<StepUpState> => {
    const response = await HttpApiService.post<StepUpState, RemoveSecurityPinBody>(
      "/auth/security-pin/remove",
      body,
    );
    return response.data;
  },
};
